/* ======================================================================
   DC SEARCH MATCHES, option S1 "page links on top" (Pete, 2026-09-23)
   Source: Website/Search Options/search-options.html

   Every search form here asks Shopify for products only, so a page like
   Golf Camp, About or Wholesale could never be found. This runs ONE extra
   request next to the product one and prints matching pages and
   collections as plain links above the products. Product results are not
   touched. `fields=title,body` lets page body text count, which is what
   makes "butler pitch" find Golf Camp Austin.

   Three places:
     1. phone menu search   -> dc-mobile-menu.liquid calls dcSearchMatches.render()
     2. header search drawer -> Impact's <predictive-search> swaps its results
        slot on every query; an observer puts the links on top of it
     3. results page        -> main-search.liquid prints [data-dc-sm-jump]
   Pages hidden with seo.hidden never come back from suggest, by design.
   ====================================================================== */
(function () {
  'use strict';
  if (window.dcSearchMatches) return;

  var cache = {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fetchMatches(q) {
    q = (q || '').trim();
    if (!q) return Promise.resolve([]);
    var key = q.toLowerCase();
    if (cache[key]) return cache[key];
    var url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') +
      'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=page,collection&resources[limit]=3&resources[options][fields]=title,body';
    cache[key] = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) {
        var res = (d && d.resources && d.resources.results) || {};
        var out = [];
        (res.pages || []).forEach(function (p) { out.push({ k: 'Page', t: p.title, u: p.url }); });
        (res.collections || []).forEach(function (c) { out.push({ k: 'Collection', t: c.title, u: c.url }); });
        return out;
      })
      .catch(function () { delete cache[key]; return []; });
    return cache[key];
  }

  /* rows: title underlined green, kind on the right (phone menu + drawer) */
  function rowsHTML(list) {
    if (!list.length) return '';
    return '<div class="dc-sm dc-sm--rows">' + list.map(function (m) {
      return '<a class="dc-sm__row" href="' + esc(m.u) + '"><span class="dc-sm__t">' + esc(m.t) +
        '</span><span class="dc-sm__k">' + m.k + '</span></a>';
    }).join('') + '</div>';
  }

  /* one line under the search box (results page) */
  function jumpHTML(list) {
    if (!list.length) return '';
    return '<span class="dc-sm__lead">Jump to</span>' + list.map(function (m) {
      return '<a class="dc-sm__link" href="' + esc(m.u) + '">' + esc(m.t) + '</a>';
    }).join('');
  }

  window.dcSearchMatches = { fetch: fetchMatches, rowsHTML: rowsHTML, jumpHTML: jumpHTML };

  /* ---------- 2. header search drawer ---------- */
  function decorateDrawer(ps) {
    var slot = ps.querySelector('[slot="results"]');
    var input = ps.closest('form') && ps.closest('form').elements.q;
    if (!slot || !input || slot.querySelector('.dc-sm')) return;
    var q = input.value.trim();
    if (!q) return;
    fetchMatches(q).then(function (list) {
      /* the slot may have been swapped again while we waited */
      if (!slot.isConnected || input.value.trim() !== q || !list.length || slot.querySelector('.dc-sm')) return;
      slot.insertAdjacentHTML('afterbegin', rowsHTML(list));
    });
  }

  function watchDrawers() {
    var nodes = document.querySelectorAll('predictive-search');
    for (var i = 0; i < nodes.length; i++) {
      var ps = nodes[i];
      if (ps.dataset.dcSm) continue;
      ps.dataset.dcSm = '1';
      var mo = new MutationObserver((function (p) { return function () { decorateDrawer(p); }; })(ps));
      mo.observe(ps, { childList: true });
    }
  }

  /* ---------- 3. results page ---------- */
  function fillJump() {
    var boxes = document.querySelectorAll('[data-dc-sm-jump]');
    for (var i = 0; i < boxes.length; i++) {
      (function (box) {
        if (box.dataset.done) return;
        box.dataset.done = '1';
        fetchMatches(box.getAttribute('data-q')).then(function (list) {
          if (!list.length) return;
          box.innerHTML = jumpHTML(list);
          box.hidden = false;
        });
      })(boxes[i]);
    }
  }

  function boot() { watchDrawers(); fillJump(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
